import React from 'react';
export function TopBar() {
  return <div className="bg-brand-deep-green text-brand-card py-2 px-4 text-center text-xs sm:text-sm font-medium tracking-wide" data-id="element-208">
      <p data-id="element-209">
        Producto 100% digital · Ideal para principiantes · Creá y vendé desde
        casa
      </p>
    </div>;
}